import { roles, typesTimesheet, typesTimesheetLabel } from "constants/index";
import { Button, Space, Table } from "antd";
import classNames from "classnames/bind";
import moment from "moment";
import style from "./index.module.scss";
import { useEffect, useMemo, useState } from "react";
import ModalCreated from "../ModalCreated";
import ModalDetailTimeSheet from '../ModalTimeSheetUser';
import { DatePicker } from "components/index";
import timesheetApi from "api/timesheet";
import { getDatesInRange } from "utils/date";
import { getUser } from "utils/index";
import { useTranslation } from "react-i18next";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
import { uniqBy, uniqWith } from "lodash";

const cx = classNames.bind(style);

export default function TableTimesheet({ openNotificationWithIcon, shop, name, isShop }) {
  const [openModal, setOpenModal] = useState(false);
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [idSelected, setIdSelected] = useState({});
  const [dataModal, setDataModal] = useState({});
  const [listTimesheet, setListTimesheet] = useState([]);
  const [listTimesheetSpringer, setListTimesheetSpringer] = useState([]);
  const [date, setDate] = useState(moment());
  const [disableFullInfo, setDisableFullInfo] = useState(isShop)

  const user = getUser();

  const { t } = useTranslation()
  const onChange = (value) => {
    setDate(value);
  };

  const listDay = useMemo(
    () => getDatesInRange(moment(date).startOf("week"), moment(date).endOf("week")),
    [date]
  );
  const listTimesheetFilter = useMemo(() => {
    if (disableFullInfo) {
      return listTimesheet.length > 0 ? [listTimesheet[0]] : listTimesheet.sort((a, b) => a.role - b.role);
    }
    if (user.role == roles.springer) return [];

    return listTimesheet.sort((a, b) => a.role - b.role);
  }, [user, disableFullInfo, listTimesheet]);

  const validateInThisYear = (logDate) => {
    return moment(logDate).year() === moment().year();
  }

  const onClickTimesheet = ({ item, value, type }) => {
    if (!validateInThisYear(item)) {
      openNotificationWithIcon("error", t('error'), t('notAllowCreateTimeSheet'));

      return;
    }
    setOpenModal(true);
    setDataModal({
      id: value[item]._id,
      logDate: item,
      userWorkId: value.userWorkId,
      user: value.full_name,
      type,
      role: value.role,
    });
  };

  const toggleFullInfo = () => {
    setDisableFullInfo(!disableFullInfo)
  }

  const getTimesheet = async () => {
    if (date) {
      const params = {
        from: moment(date).startOf("week").format("YYYY-MM-DD"),
        to: moment(date).endOf("week").format("YYYY-MM-DD"),
      };
      try {
        const res = await timesheetApi.getTimesheet(shop, params);
        if (res.success) {
          setListTimesheet(res.list.filter(item => item.role != roles.springer));
          setListTimesheetSpringer(res.list.filter(item => item.role == roles.springer));
        }
      } catch (error) {
        openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
      }
    }
  };

  const handleDetailTimeSheet = (id) => {
    setOpenModalDetail(true);
    setIdSelected(id)
  }

  useEffect(() => {
    getTimesheet();
  }, [date]);

  useEffect(() => {
    !openModal && setDataModal({});
  }, [openModal]);

  const columns = useMemo(() => {
    const columnsHeader = !disableFullInfo ? [
      {
        title: t('fullName'),
        dataIndex: "full_name",
        key: "full_name",
        onCell: (row) => ({
          onClick: () => handleDetailTimeSheet(row._id)
        }),
        render: (value, row) => ({
          props: {
            style: {
              backgroundColor: row?.role === roles.staffShop && '#FFEEBB',
              cursor: "pointer",
            },
          },
          children: <p>{value}</p>,
        })
      },
    ] : listTimesheetSpringer.length > 0 ? [{
      title: '',
      dataIndex: '',
      key: '',
    }] : []

    return listTimesheet[0]
      ? columnsHeader.concat(
        Object.keys(listTimesheet[0])
          .filter((item) => moment(item).isValid())
          .map((item) => {
            return {
              title: item,
              dataIndex: item,
              key: item,
              align: "center",
              onCell: (value) => ({
                onClick: () => !isShop
                  && ([roles.shopManager, roles.areaManager, roles.springer].includes(+user.role))
                  && !value[item].isHoliday
                  && moment(item).weekday()
                  && onClickTimesheet({ item, value, type: value[item].type }),
              }),
              render: (value) => {
                let count = 0;

                listTimesheet.map((row) => {
                  if (
                    Number(row[item].type) === typesTimesheet.work
                    // &&
                    // (!row.leftAt ||
                    //   (row.leftAt &&
                    //     (moment(row.leftAt).isSameOrAfter(moment(item)))))
                  ) {
                    return count++;
                  }
                });

                return !disableFullInfo
                  ? {
                    props: {
                      style: {
                        textAlign: "center",
                        backgroundColor:
                          (value.isHoliday || !moment(item).weekday()) ? '#30A2FF' :
                            value.type == typesTimesheet.work
                              ? "#82CD47"
                              : value.type == typesTimesheet.sick
                                ? "#DF2E38"
                                : value.type == typesTimesheet.notWork
                                  ? "#9DB2BF"
                                  : value.type == typesTimesheet.absence
                                    ? "#F0FF42"
                                    : "#fff",
                        cursor: "pointer",
                      },
                    },
                    children: value.isHoliday ? t('holiday') : !moment(item).weekday() ? t('weekend') : <div>{t(`${typesTimesheetLabel[value.type]}`)}</div>,
                  }
                  : {
                    props: {
                      style: {
                        textAlign: "center",
                        backgroundColor:
                          (value.isHoliday || !moment(item).weekday()) ? '#30A2FF' :
                            count === listTimesheet.length
                              ? "#5F8D4E"
                              : listTimesheet.length - count < 2
                                ? "#FFB84C"
                                : "#DF2E38",
                        cursor: "pointer",
                      },
                    },
                    children: value.isHoliday ? t('holiday') : !moment(item).weekday() ? t('weekend') : <div>{`${count}/${listTimesheet.length}`}</div>,
                  };
              },
            };
          })
      )
      : columnsHeader.concat(
        listDay.map((day) => {
          return {
            title: day,
            dataIndex: day,
            key: day,
            align: "center",
          };
        })
      );
  }, [isShop, disableFullInfo, listDay, listTimesheet, t, user.role]);

  return (
    <>
      <DatePicker onChange={onChange} picker="week" value={date} style={{ marginBottom: 8 }} />
      <br />
      <Space>
        <span style={{ margin: "15px 0px", fontWeight: "bold" }}>{name}</span>
        {
          getUser().role === roles.departmentManager && <Button icon={disableFullInfo ? <EyeFilled /> : <EyeInvisibleFilled />} onClick={toggleFullInfo} />
        }
      </Space>
      <Table
        className={cx('table-timesheet', user.role == roles.springer && 'table-springer')}
        dataSource={listTimesheetFilter}
        columns={columns}
        bordered
        pagination={false}
        summary={(pageData) => {
          return (
            <Table.Summary fixed>
              {
                !disableFullInfo &&
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} align="left" className="cell-total">
                    {t('sum')}
                  </Table.Summary.Cell>
                  {listTimesheet[0] &&
                    Object.keys(listTimesheet[0])
                      .filter((item) => moment(item).isValid())
                      .map((item, index) => {
                        let count = 0;
                        let hasHoliday = false

                        listTimesheet.map((row) => {
                          if (row[item].isHoliday) {
                            hasHoliday = true
                          }
                          if (
                            Number(row[item].type) === typesTimesheet.work
                            // &&
                            // (!row.leftAt 
                            //   ||
                            //   (row.leftAt &&
                            //     (moment(row.leftAt).isSameOrAfter(moment(item))))
                            // )
                          ) {
                            return count++;
                          }
                        });

                        return (
                          <Table.Summary.Cell
                            key={item}
                            index={index + 1000}
                            align="center"
                            className={
                              (hasHoliday || !moment(item).weekday()) ? cx('bg-4') :
                                count === listTimesheet.length
                                  ? cx("bg-1")
                                  : listTimesheet.length - count < 2
                                    ? cx("bg-2")
                                    : cx("bg-3")
                            }
                          >
                            {hasHoliday ? t('holiday') : !moment(item).weekday() ? t('weekend') : `${count}/${listTimesheet.length}`}
                          </Table.Summary.Cell>
                        );
                      })}
                </Table.Summary.Row>
              }
              {
                listTimesheetSpringer.length > 0 &&
                  listTimesheetSpringer.map((springer, index) => 
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} align="left" className="cell-total">
                        <div onClick={() => handleDetailTimeSheet(springer._id)}>{springer.full_name}</div>
                      </Table.Summary.Cell>
                      {listTimesheet[0] &&
                        Object.keys(listTimesheet[0])
                          .filter((date) => moment(date).isValid())
                          .map((date, index) => {
                            return (
                              <Table.Summary.Cell
                                key={date}
                                index={index + 1000}
                                align="center"
                                className={
                                  (springer[date].isHoliday || !moment(date).weekday()) ? cx('bg-4') :
                                    springer[date].type == typesTimesheet.work
                                      ? cx('bg-1')
                                      : springer[date].type == typesTimesheet.sick
                                        ? cx('bg-3')
                                        : springer[date].type == typesTimesheet.notWork
                                          ? cx('bg-5')
                                          : springer[date].type == typesTimesheet.absence
                                            ? cx('bg-6')
                                            : cx('bg-7')
                                }
                              >
                                <div onClick={() => {
                                  if (user.role == roles.springer || user.role == roles.departmentManager) {
                                    onClickTimesheet({ item: date, value: springer, type: springer[date].type })
                                  }
                                }}>
                                  {springer[date].isHoliday ? t('holiday') : !moment(date).weekday() ? t('weekend') : t(`${typesTimesheetLabel[springer[date].type]}`)}
                                </div>
                              </Table.Summary.Cell>
                            );
                          })}
                    </Table.Summary.Row>
                  )
              }
            </Table.Summary>
          );
        }}
      />

      <ModalDetailTimeSheet
        openModal={openModalDetail}
        setOpenModal={setOpenModalDetail}
        id={idSelected}
        setId={setIdSelected}
        openNotificationWithIcon={openNotificationWithIcon}
      />

      <ModalCreated
        openModal={openModal}
        setOpenModal={setOpenModal}
        openNotificationWithIcon={openNotificationWithIcon}
        dataModal={dataModal}
        getTimesheet={getTimesheet}
      />
    </>
  );
}
